import { Component, Input, OnInit, Renderer2, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalstorageService } from 'src/app/service/shared/localstorage/localstorage.service';
import { ToolSearchParams } from 'src/app/shared/models/toolSearchParams';
import { DialogService } from 'src/app/service/dialog/dialog.service';
import { DOCUMENT } from '@angular/common';
import { ToastService } from 'src/app/service/shared/toast/toast.service';
import { ConfigurationService } from './configuration.service';
import { JobPointePermissionsService } from 'src/app/service/auth/job-pointe-permission.service';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss'],
})
export class ConfigurationComponent implements OnInit {
  @Input() userPermissions: any;
  defaultObject: any = {
    label: '',
    type: '',
    editAccess: true,
    statusToggle: true,
    columns: [
      { name: 'name', label: 'Name', property: 'name', sortable: true },
      {
        name: 'description',
        label: 'Description',
        property: 'description',
        sortable: true,
      },
    ],
    rowActions: [
      {
        label: 'Edit',
        actionId: 'edit',
        imageUrl: '',
        iconName: 'far fa-pen',
        show: row => {
          return this.jobPointePermissionsService.isAllowed(row, 'job_pointe_configuration', 'edit');
        },
        // show: (x) => {
        //   return true
        // },
      },
      {
        label: 'Copy',
        actionId: 'copy',
        imageUrl: '',
        iconName: '',
        // show: (x) => false,
        show: row => {
          return this.jobPointePermissionsService.isAllowed(row, 'job_pointe_configuration', 'edit');
        },
      },
      {
        label: 'Delete',
        actionId: 'delete',
        imageUrl: '',
        iconName: 'far fa-trash',
        // show: (x) => true,
        show: row => {
          return this.jobPointePermissionsService.isAllowed(row, 'job_pointe_configuration', 'edit');
        },
      },
    ],
    data: [],
  };
  attributes;
  configurationSettingsData: any = {
    attributes: Object.assign({}, this.defaultObject, {
      label: 'Attributes/Certifications',
      type: 'attributes',
    }),
    'employee-types': Object.assign({}, this.defaultObject, {
      label: 'Employee Types',
      type: 'employee-types',
      columns: [
        { name: 'icon', label: 'Icon', property: 'color', sortable: false },
        { name: 'name', label: 'Type', property: 'name', sortable: true },
        { name: 'rank', label: 'Rank', property: 'rank', sortable: true },
        {
          name: 'description',
          label: 'Description',
          property: 'description',
          sortable: true,
        },
      ],
      rowActions: [
        {
          label: 'Edit',
          actionId: 'edit',
          imageUrl: '',
          iconName: 'far fa-pen',
          show: row => {
            // return true;
            return this.jobPointePermissionsService.isAllowed(row, 'job_pointe_configuration', 'edit');
          },
        },
        {
          label: 'Delete',
          actionId: 'delete',
          imageUrl: '',
          iconName: 'far fa-trash',
          // show: (x) => false,
          show: row => {
            return this.jobPointePermissionsService.isAllowed(row, 'job_pointe_configuration', 'edit');
          },
        },
      ],
    }),
  };

  configurationPagingData: any = {};
  currentPath: string;
  tabList: Array<string>;

  searchParams: ToolSearchParams = { page: 1, limit: 50, order: 'name,asc' };
  newRecord: any = {};
  dialogRecord: any = {};
  actionNameMap: any = {
    edit: 'Edit',
    create: 'Add',
    delete: 'Delete',
    status: 'Enable/Disable',
  };

  constructor(
    private activeRoute: ActivatedRoute,
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private _document,
    private localStorageService: LocalstorageService,
    private configurationService: ConfigurationService,
    private DialogService: DialogService,
    private toastService: ToastService,
    private jobPointePermissionsService: JobPointePermissionsService,
  ) {}

  ngOnInit(): void {
    // generate a dynamic list of tabs, based on the object's keys
    this.tabList = Object.keys(this.configurationSettingsData);
    // parse out the permissions prop, from the user, in localStorage
    this.userPermissions = JSON.parse(JSON.parse(this.localStorageService.getItem('user'))['permissions']);
    this.activeRoute.url.subscribe(url => {
      this.currentPath = url[0].path;
      this.getConfigurationData();
    });
    if (this.currentPath === 'employee-types') this.searchParams.order = 'rank,asc';
  }

  isCurrentPath(path: string): Boolean {
    return this.currentPath === path;
  }

  handleAction(actionData): void {
    const { action, payload } = actionData;
    if (this.jobPointePermissionsService.isAllowed('', 'job_pointe_configuration', 'edit')) {
      this.actions[action](payload);
    }
  }

  handlePermission() {
    Object.keys(this.configurationSettingsData).forEach(i => {
      this.configurationSettingsData[i].statusToggle = !!this.userPermissions.tools_setting.edit;

      this.configurationSettingsData[i].editAccess = !!this.userPermissions.tools_setting.edit;
    });
  }

  actions = {
    edit: record => this.performUpdate(record),
    delete: record => this.performDelete(record),
    status: record => this.performStatusChange(record),
    sort: sortData => this.performSorting(sortData),
  };

  setDataToControl(field, value) {
    this.newRecord.assetClassId = value;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.loadSelect2();
    }, 300);
  }

  handleToggle(enabled: boolean) {
    this.newRecord.status = enabled;
  }

  loadSelect2() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  performSearch(searchText: string) {
    this.searchParams.search = searchText;
    this.getConfigurationData();
  }

  performSorting(sortData: any) {
    this.searchParams.order = sortData;
    this.getConfigurationData();
  }

  performCreate(type: string): void {
    this.dialogRecord.settingType = this.configurationSettingsData[type].label;
    this.dialogRecord.actionType = 'create';
    this.dialogRecord.actionName = 'Add';

    // Check if the user has the permission to edit
    const hasEditPermission = this.jobPointePermissionsService.isAllowed('', 'job_pointe_configuration', 'edit');

    if (type == 'employee-types') {
      this.newRecord = {
        name: '',
        description: '',
        status: !!hasEditPermission,
        rank: '',
        icon: '',
      };
    }
    if (type == 'attributes') {
      this.newRecord = {
        name: '',
        description: '',
        status: !!hasEditPermission,
      };
    }
    this.DialogService.open('configuration-dialog').then(response => {
      // if user decided to continue, proceed with change
      if (response) {
        this.configurationService.create[type](this.newRecord).subscribe(
          () => {
            this.toastService.showToast('Successfully created', 'success');
            this.getConfigurationData();
          },
          err => {
            this.toastService.showToast('Failed to create new record', 'error');
            console.error('error:', err);
          },
        );
      }
    });
  }

  getConfigurationData() {
    this.configurationService.read[this.currentPath](this.searchParams).subscribe(
      res => {
        this.configurationSettingsData[this.currentPath].data = res.data;
        this.configurationPagingData[this.currentPath] = res.pagination;
        this.handlePermission();
      },
      error => {
        console.error(error);
      },
    );
  }

  performPaging(pageLink: string): void {
    if (parseInt(pageLink)) {
      this.searchParams.page = parseInt(pageLink);
    }
    this.getConfigurationData();
  }

  performUpdate(record): void {
    this.dialogRecord.settingType = this.configurationSettingsData[this.currentPath].label;
    this.dialogRecord.actionType = 'edit';
    this.dialogRecord.actionName = 'Edit';
    this.newRecord = record;

    this.DialogService.open('configuration-dialog').then(response => {
      // if user decided to continue, proceed with change
      if (response) {
        const { id } = record;
        const payload = { id, data: this.newRecord };
        this.configurationService.update[this.currentPath](payload).subscribe(
          () => {
            this.toastService.showToast('Successfully updated record', 'success');
            this.getConfigurationData();
          },
          err => {
            this.toastService.showToast('Failed to update record', 'error');
            console.error('error:', err);
          },
        );
      } else {
        this.getConfigurationData();
      }
    });
  }

  performDelete(record): void {
    this.dialogRecord.settingType = this.configurationSettingsData[this.currentPath].label;
    this.dialogRecord.actionType = 'delete';
    this.dialogRecord.actionName = 'Delete';
    this.dialogRecord.data = record;

    this.DialogService.open('configuration-dialog').then(response => {
      // if user decided to continue, proceed with change
      if (response) {
        this.configurationService.delete[this.currentPath](record.id).subscribe(
          () => {
            this.toastService.showToast('Successfully deleted record', 'success');
            this.getConfigurationData();
          },
          err => {
            this.toastService.showToast('Failed to delete record', 'error');
            console.error('error:', err);
          },
        );
      }
    });
  }

  performStatusChange(record): void {
    const { id, status } = record;
    const payload = { id, status: !status };
    this.configurationService.status[this.currentPath](payload).subscribe(
      () => {
        this.getConfigurationData();
        this.toastService.showToast('Successfully updated status', 'success');
      },
      err => {
        this.toastService.showToast('Error in updating status', 'error');
        console.error('error:', err);
      },
    );
  }
}
